import {srcUrl} from "@/api/ImageApi.ts";
import {Scene} from "@/scenes/Scene.ts";


export default function PlayerSceneView({scene}: { scene: Scene }) {
    return (
        <div className="flex size-full justify-center overflow-hidden">
            <img src={srcUrl(scene.image)} alt="" className="size-full object-contain"/>
        </div>)
}
